import { useInput } from 'react-admin';
import {
  TextField,
  Chip,
  Box,
  Typography,
  useTheme,
} from '@mui/material';
import { useState } from 'react';

const CustomTagInput = (props: any) => {
  const {
    field: { value, onChange, onBlur },
    fieldState,
    isRequired,
  } = useInput(props);
  const label = props.label;
  const theme = useTheme();
  const [input, setInput] = useState('');

  const tags: string[] = Array.isArray(value)
    ? value.filter((tag) => tag && tag.trim() !== '')
    : typeof value === 'string' && value !== ''
    ? [value]
    : [];

  const addTokens = (tokens: string[]) => {
    const merged = [...tags];
    tokens.forEach((token) => {
      const trimmed = token.trim();
      if (trimmed && !merged.includes(trimmed)) {
        merged.push(trimmed);
      }
    });
    if (merged.length !== tags.length) {
      onChange(merged);
    }
  };

  const commitTag = () => {
    const trimmed = input.trim();
    if (trimmed && !tags.includes(trimmed)) {
      onChange([...tags, trimmed]);
    }
    setInput('');
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    // Split a tag whenever a space or comma is typed (also handles pasted lists).
    if (/[\s,]/.test(raw)) {
      const parts = raw.split(/[\s,]+/);
      const remainder = parts.pop() ?? '';
      addTokens(parts);
      setInput(remainder);
    } else {
      setInput(raw);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && input.trim()) {
      e.preventDefault();
      commitTag();
    }
  };

  const handleBlur = () => {
    // Commit any pending text so a typed-but-not-entered tag is not lost on submit.
    commitTag();
    onBlur?.();
  };

  const handleDelete = (tagToDelete: string) => {
    onChange(tags.filter((tag) => tag !== tagToDelete));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1,
          alignItems: 'center',
          
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 1,
          padding: '6px 8px',
          backgroundColor: theme.palette.background.paper,
        }}
      >
        {tags.map((tag, i) => (
          <Chip
            key={i}
            label={tag}
            onDelete={() => handleDelete(tag)}

            sx={{
              fontWeight: 500,
              fontSize: '0.75rem',
            }}
          />
        ))}
        <TextField
          variant="standard"
          value={input}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          placeholder={label}
          InputProps={{
            disableUnderline: true,
          }}
          sx={{ flex: 1}}
        />
      </Box>
      {fieldState?.error && (
        <Typography color="error" variant="caption">
          {fieldState.error.message}
        </Typography>
      )}
    </Box>
  );
};

export default CustomTagInput;
